function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.7071 1.29289C18.0976 1.68342 18.0976 2.31658 17.7071 2.70711L14.9142 5.5L18.5 9.08579L21.2929 6.29289C21.6834 5.90237 22.3166 5.90237 22.7071 6.29289C23.0976 6.68342 23.0976 7.31658 22.7071 7.70711L19.9108 10.5034C20.9631 11.6814 20.9237 13.4905 19.7929 14.6213L17.7071 16.7071C15.0711 19.3431 10.934 19.5629 8.04761 17.3666L2.70711 22.7071C2.31658 23.0976 1.68342 23.0976 1.29289 22.7071C0.902369 22.3166 0.902369 21.6834 1.29289 21.2929L6.63339 15.9524C4.43709 13.066 4.65692 8.92886 7.29289 6.29289L9.37868 4.20711C10.5095 3.07625 12.3186 3.03695 13.4966 4.0892L16.2929 1.29289C16.6834 0.902369 17.3166 0.902369 17.7071 1.29289ZM12.2071 5.62132C11.8166 5.2308 11.1834 5.2308 10.7929 5.62132L8.70711 7.70711C6.61235 9.80186 6.61235 13.1981 8.70711 15.2929C10.8019 17.3877 14.1981 17.3876 16.2929 15.2929L18.3787 13.2071C18.7692 12.8166 18.7692 12.1834 18.3787 11.7929L12.2071 5.62132Z"
});

function Svg23(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg23);
export default __webpack_public_path__ + "static/media/2_3.c99181ee.svg";
export { ForwardRef as ReactComponent };